module.exports = __webpack_public_path__ + "img/Cellpuri.236d85f7.png";